import React, { useEffect, useState} from 'react'
import { Route, Routes, useSearchParams } from 'react-router-dom'
import roles from '../auth/roles'

import DashboardLayout from '../components/layouts/DashboardLayout'
import HomeLayout from '../components/layouts/HomeLayout'
import Home from '../pages/Home'
import Login from '../pages/Login'
import NotFoundPage from '../pages/NotFoundPage'
import Register from '../pages/Register'
import routes from './helpers/routes'
import PrivateRoute from './PrivateRoute'
import PublicRoute from './PublicRoute'
import Content from '../components/Content';
import ContentAdmin from '../pages/admin/ContentAdmin'
import NewContact from '../components/user/NewContact'
import NewMessage from '../components/user/NewMessage'
import Historial from '../components/user/Historial'
import Groups from '../components/user/Groups'
import NewLink from '../components/user/NewLink'
import Links from '../components/user/Links'
import FreeMessage from '../components/user/FreeMessage'
import MyMessages from '../components/user/MyMessages'
import ApprovedMessages from '../components/user/ApprovedMessages'
import ApproveMessages from '../components/admin/ApproveMessages'
import AddCredits from '../components/admin/AddCredits'
import ListAuthMessage from '../components/admin/ListAuthMessage'
import ResetPassword from '../pages/ResetPassword'


const AppRouter = () => {

  const [width, setWidth] = useState(window.innerWidth);
  
  const handleDisplay = () => {
    setWidth(window.innerWidth);
  }
  
  const [toggleSidebar, setToggleSidebar] = useState(width > 995);

  const handleToggle = () => {
    setToggleSidebar(!toggleSidebar)
  }
  
  useEffect(() => {
    window.addEventListener('resize', handleDisplay)
    return ()=> {
      window.removeEventListener('resize', handleDisplay)
    }
  })

  
  const [searchParams] = useSearchParams();
  const dataParams= Object.fromEntries([...searchParams]);
  const emailRegister = dataParams.email;
  const tokenRegister = dataParams.token;

    return (
      <>
      
          <Routes>
              <Route path={routes.home} element={<HomeLayout width= {width} />}>
                <Route index element={<Home />} />
                <Route path={routes.login} element={<PublicRoute> <Login admin= {false} /> </PublicRoute>} />
                <Route path={routes.reset_password} element={<PublicRoute> <ResetPassword /> </PublicRoute>} />
                <Route path={routes.admin} element={<PublicRoute> <Login admin = {true} /> </PublicRoute>} />
                <Route path={routes.register} element={<PublicRoute  emailRegister= {emailRegister} tokenRegister = {tokenRegister}  > <Register emailRegister= {emailRegister} tokenRegister = {tokenRegister} /> </PublicRoute>} />
                <Route path='*' element={<NotFoundPage />} />
              </Route>

              <Route path={routes.dashboard} element={<PrivateRoute><DashboardLayout handleToggle = {handleToggle} toggleSidebar= {toggleSidebar}  width= {width} /></PrivateRoute>}>
                <Route path={routes.dashboardUser} element={<PrivateRoute hasRole={roles.user}> <Content toggleSidebar = {toggleSidebar} width= {width}  /> </PrivateRoute>} />
                
                <Route path={routes.freeMessages} element={<PrivateRoute hasRole={roles.user}> <FreeMessage toggleSidebar = {toggleSidebar} width= {width}  /> </PrivateRoute>} />
                <Route path={routes.newMessage} element={<PrivateRoute hasRole={roles.user}> <NewMessage toggleSidebar = {toggleSidebar} width= {width}  /> </PrivateRoute>} />
                <Route path={routes.pendingMessages} element={<PrivateRoute hasRole={roles.user}> <MyMessages toggleSidebar = {toggleSidebar} width= {width}  /> </PrivateRoute>} />
                <Route path={routes.myMessages} element={<PrivateRoute hasRole={roles.user}> <ApprovedMessages toggleSidebar = {toggleSidebar} width= {width}  /> </PrivateRoute>} />
                <Route path={routes.historial} element={<PrivateRoute hasRole={roles.user}> <Historial toggleSidebar = {toggleSidebar} width= {width}  /> </PrivateRoute>} />
                <Route path={routes.newContact} element={<PrivateRoute hasRole={roles.user}> <NewContact toggleSidebar = {toggleSidebar} width= {width}  /> </PrivateRoute>} />
                <Route path={routes.groups} element={<PrivateRoute hasRole={roles.user}> <Groups toggleSidebar = {toggleSidebar} width= {width}  /> </PrivateRoute>} />
                <Route path={routes.newLink} element={<PrivateRoute hasRole={roles.user}> <NewLink toggleSidebar = {toggleSidebar} width= {width}  /> </PrivateRoute>} />
                <Route path={routes.links} element={<PrivateRoute hasRole={roles.user}> <Links toggleSidebar = {toggleSidebar} width= {width}  /> </PrivateRoute>} />
                <Route path={routes.admin} element={<PrivateRoute hasRole = {roles.admin} > <ContentAdmin /> </PrivateRoute>} />
                <Route path={routes.approvedMessage} element={<PrivateRoute hasRole = {roles.admin} > <ApproveMessages toggleSidebar = {toggleSidebar} width= {width} /> </PrivateRoute>} />
                <Route path={routes.addcredits} element={<PrivateRoute hasRole = {roles.admin} > <AddCredits toggleSidebar = {toggleSidebar} width= {width} /> </PrivateRoute>} />
                <Route path={routes.authmessages} element={<PrivateRoute hasRole = {roles.admin} > <ListAuthMessage toggleSidebar = {toggleSidebar} width= {width} /> </PrivateRoute>} />
              
              </Route>
          </Routes>
      </>
    )
}

export default AppRouter
